export default __webpack_public_path__ + "static/media/p3-8.4a0beba4.png";